import 'zone.js/dist/zone-error';

export const environment = {
    production: true,
    azure_ClientId: '5b4f9faa-9d95-48d0-bdc3-de259423f318',
    webapiURL: "https://o9nuapat4d.execute-api.sa-east-1.amazonaws.com/PRD",
    xApiKey: 'VthEoj5ntK1mnIssBYgor4SPvUztieLf8A8Fse9b',
    s3BasePath: 's3.sa-east-1.amazonaws.com',
};
